<template>
  <section class="rake-and-tip-settings settings">
    <header>
      <h1 class="page-header">Rake and tip</h1>
    </header>
    <form>
      <section class="form-group">
        <label>
          Pot size ($):
          <input type="number" class="form-control input-lg" ref="potSize" v-bind:value="settings.equityCalculator.rakeAndTip.potSize" min="0">
        </label>
      </section>
      <section class="form-group">
        <label>
          Rake percentage <a href="https://www.pokerschoolonline.com/articles/Beginning-Poker-11-Rake-Considerations">(usually 5-10%)</a>:
          <input type="number" class="form-control input-lg" ref="initialRakePercentage" v-bind:value="settings.equityCalculator.rakeAndTip.initialRakePercentage" min="0" max="100">
        </label>
      </section>
      <section class="form-group">
        <label>
          Rake cap <a href="https://www.pokernews.com/strategy/las-vegas-poker-cash-games-rake-comps-27539.htm">(usually $3-5)</a>:
          <input type="number" class="form-control input-lg" ref="rakeCap" v-bind:value="settings.equityCalculator.rakeAndTip.rakeCap" min="0">
        </label>
      </section>
      <section class="form-group">
        <label>
          Tip amount ($):
          <input type="number" class="form-control input-lg" ref="tipAmount" v-bind:value="settings.equityCalculator.rakeAndTip.tipAmount" min="0">
        </label>
      </section>
    </form>
    <hr>
    <section class="buttons">
      <button class="btn btn-default btn-lg" v-on:click="isHelpVisible = !isHelpVisible">
        <span v-if="!isHelpVisible">Show help <span class="caret-down"></span></span>
        <span v-if="isHelpVisible">Hide help <span class="caret-up"></span></span>
      </button>
      <button type="button" class="btn btn-default btn-lg" v-on:click="resetRakeAndTip()">Set to defaults</button>
      <button type="button" class="btn btn-primary btn-lg" v-on:click="saveRakeAndTip()">Save</button>
    </section>
    <section v-if="isHelpVisible" class="well">
      <p>Setting the rake and/or the tip will affect the resulting equity.</p>
      <p>If you think about it, that makes sense. If you win a $100 pot and the house takes $5 for rake, in a very real sense, the house has 5% equity in the pot. Similarly, if you win a $100 pot and tip the dealer $5, the dealer has 5% equity.</p>
      <p>If the house and dealer both have some equity in the hand, it will slightly reduce the amount of equity that the players have, which will be reflected in the equity calculator.</p>
    </section>
  </section>
</template>

<script>
export default {
  name: 'rake-and-tip-settings',
  data: function () {
    return {
      isHelpVisible: false,
    };
  },
  computed: {
    settings: function () {
      return this.$store.state.account.user.settings;
    },
  },
  methods: {
    saveRakeAndTip: function () {
      let user = _.cloneDeep(this.$store.state.account.user);
      let self = this;

      user.settings.equityCalculator.rakeAndTip = self._getRakeAndTip();
      self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    _getRakeAndTip: function () {
      let rakePercentage;
      let tipPercentage;
      let potSize = Number(this.$refs.potSize.value);
      let initialRakePercentage = Number(this.$refs.initialRakePercentage.value);
      let rakeCap = Number(this.$refs.rakeCap.value);
      let tipAmount = Number(this.$refs.tipAmount.value);
      let rakeAndTip = {};

      // set potSize, initialRakePercentage, rakeCap, and tipAmount
      rakeAndTip.potSize = potSize;
      rakeAndTip.initialRakePercentage = initialRakePercentage;
      rakeAndTip.rakeCap = rakeCap;
      rakeAndTip.tipAmount = tipAmount;

      // calculate rake and tip percentage
      rakePercentage = Math.min(
        initialRakePercentage,
        ((rakeCap / potSize) * 100)
      );
      tipPercentage = (tipAmount / potSize) * 100;

      // set rake and tip percentage
      rakeAndTip.rakePercentage = rakePercentage;
      rakeAndTip.tipPercentage = tipPercentage;

      return rakeAndTip;
    },
    resetRakeAndTip: function () {
      let self = this;
      let user = _.cloneDeep(this.$store.state.account.user);
      let defaultRakeAndTip = {
        potSize: 100,
        initialRakePercentage: 0,
        rakeCap: 0,
        tipAmount: 0,
        rakePercentage: 0,
        tipPercentage: 0,
      };

      user.settings.equityCalculator.rakeAndTip = defaultRakeAndTip;
      self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/settings';
</style>



// WEBPACK FOOTER //
// src/components/settings/equity-calculator/rake-and-tip.vue